import { RULES_CONSTANT } from 'constant/RuleConstant';

interface KTreeDefinitionPayloadParams {
  ruleTypeCode?: string;
  ktreeDefinitionId?: string | number;
  inferenceKTreeDefinitionId?: string | number;
}

export function isKTreeParentAttributeInferenceRule(ruleTypeCode?: string) {
  return ruleTypeCode === RULES_CONSTANT.ASSOCIATED_SUBJECT.RULE_KTREE_PARENT_ATTRIBUTE_INFERENCE;
}

export function buildKTreeDefinitionPayload({
  ruleTypeCode,
  ktreeDefinitionId,
  inferenceKTreeDefinitionId,
}: KTreeDefinitionPayloadParams) {
  if (isKTreeParentAttributeInferenceRule(ruleTypeCode)) {
    return {
      inferenceKTreeDefinitionId,
    };
  }

  return {
    ktreeDefinitionId,
  };
}
